import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text } from 'rebass/styled-components';
import { Mail, ChevronDown } from 'lucide-react';
import { Dropdown } from 'components/molecules/dropdown';
import pluralize from 'pluralize';
import { ContactEmailDropdownContent } from './contactEmailDropdownContent';

export const ContactEmailDropdown = ({ contact }) => {
  const personalEmail = contact.email || contact.personalEmails?.[0];
  const { workEmails } = contact;
  const emails = [...(workEmails ?? []), personalEmail].filter(Boolean);

  return (
    <Box
      sx={{
        minWidth: '24px',
        maxHeight: '24px',
        height: '24px',
        justifyContent: 'center',
        cursor: 'pointer',
        alignItems: 'center',
      }}
      display="flex"
      role="button"
      tabIndex={0}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
      }}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          event.stopPropagation();
        }
      }}
    >
      <Dropdown
        placement="bottom-start"
        icon={null}
        trigger={
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              fontSize: '14px',
              color: 'text.subtle',
            }}
          >
            <Box width="16px" height="16px" as={Mail} sx={{ color: 'text.subtle', flex: '0 0 auto' }} />
            {emails.length > 0 && (
              <Text>
                {emails.length} {pluralize('email', emails.length)}
              </Text>
            )}
            {emails.length === 0 && <Text>No emails</Text>}
            <ChevronDown size={16} />
          </Box>
        }
        closeOnBlur
      >
        <ContactEmailDropdownContent workEmails={workEmails} personalEmail={personalEmail} />
      </Dropdown>
    </Box>
  );
};

ContactEmailDropdown.propTypes = {
  contact: PropTypes.object.isRequired,
};
